class auto_select {

    constructor() {
        this.length_combi_index = 0;
        this.sorted_length_combis = [];
        this.auto_select = false;
    }

    reset() {
        this.length_combi_index = 0;
        this.sorted_length_combis = [];
        this.auto_select = false;
    }

    async calculate_length_combis_ajax () {
        var datatosend = fd.get();
        datatosend.action = 'fl_gasspring_configurator_auto_select';
        datatosend.sub_action = 'calculate_length_combis';
        datatosend.security = texts.security;

        var self = this;
        return $.ajax({
            url: texts.ajaxurl,
            data: datatosend,
            type: 'post',
            success: function (result) {
                var result_decoded = JSON.parse(result);
                self.sorted_length_combis = result_decoded;
                self.gs_desc_list = self.sorted_length_combis.map(item => item.gs);
            },
            error: function (xhr, status, err) {
            }
        });
    }
    async calculate_length_combis() {
        this.reset();
        await this.calculate_length_combis_ajax();
    }

    async set_length_combi() {
        if (this.sorted_length_combis.length && typeof (this.sorted_length_combis[this.length_combi_index]) !== 'undefined') {
            var combi = this.sorted_length_combis[this.length_combi_index];
            $('#gasspring').val(combi.gs);
            await cf.change_gasspring(false);

            $('#mp_cyl').val(combi.mp_cyl);
            $('#mp_rod').val(combi.mp_rod);
        } else {
            throw new Error('No length combi found by server');
        }
    }
}